export const styles = {
    cardTypeContainer: {
        display: 'inline-block'
    },
    cardType: {
        display: "inline-block",
        color: 'rgb( 72, 217, 96 )',
        backgroundColor: 'rgba( 72, 217, 96, 0.41 )',
        fontSize: "13px",
        padding: "1px 5px",
        fontWeight: "bold",
    },
    paycodeCard: {
        backgroundColor: '#FFF',
        border: '1px solid #D7D7D7',
        borderLeft: '4px solid #0A54A2',
        borderRadius: 5,
        minHeight: '65px',
        padding: '5px 10px',
        marginBottom: '5px',
        '&:last-child': {
            marginBottom: '0px'
        }
    }
};